import React from 'react';

import { Link } from 'gatsby';

import { useMixpanel } from '../../functions/Mixpanel';

import * as style from './Dropdown.module.css';

function Dropdown({ item }) {
  const { mixpanel } = useMixpanel();

  return (
    <div role="article">
      <ul className={style.dropdownMenu} role="presentation">
        {item.subMenu.map((subMenuItem, index) => {
          return (
            <Link
              to={subMenuItem.path}
              key={index}
              className={style.headerLinks}
              onClick={() => {
                mixpanel.track('Navigate Header', {
                  'Header Tab': subMenuItem.title,
                });
              }}
              activeClassName="active"
            >
              {subMenuItem.title}
            </Link>
          );
        })}
      </ul>
    </div>
  );
}

export default Dropdown;
